<template>
  <el-container>
    <el-header><h2>中科新创（北京）科技有限公司 —— 门户后台管理系统</h2></el-header>
    <el-container>
      <el-aside width="201px">
        <el-row class="tac">
          <!--<el-radio-group v-model="isCollapse" >-->
            <!--<el-radio-button :label="false">全部展开</el-radio-button>-->
            <!--<el-radio-button :label="true">全部收起</el-radio-button>-->
          <!--</el-radio-group>-->
          <el-col>
            <el-menu
              default-active="申请管理"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose">
              <div v-for="(item,index) in menuList">
                <el-submenu :index="item.name" v-if="item.children">
                  <template slot="title">
                    <i class="el-icon-setting"></i>
                    <span>{{item.name}}</span>
                  </template>
                    <span v-for="(sub_item,sub_index) in item.children">
                      <router-link tag="li" :to="sub_item.url">
                        <el-menu-item :index="sub_item.name">
                          <a>{{sub_item.name}}</a>
                        </el-menu-item>
                      </router-link>
                    </span>
                </el-submenu>
                <el-menu-item v-else :index="index.toString()">
                  <router-link tag="li" :to="item.url">
                    <i class="el-icon-setting"></i>
                    <span>{{item.name}}</span>
                  </router-link>
                </el-menu-item>
              </div>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

  export default {
    name: "ManageHome",
    mounted() {
      const self = this
      let postData = self.$qs.stringify({})
        // manage/user/menu  menu/list
      self.$http.post(self.$host+'menu/list',
        postData,
      ).then(function (response) {
        // console.log(response.data)
        self.$common.loginCheck(response.data.content)
        self.menuList = response.data.content;
      }).catch(e => {
        console.log(e)
      })
    },
    data(){
      return {
        menuList:[],
        // isCollapse: false
      }
    },
    methods: {

      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style scoped>
  html, body {
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin: 0;
  }
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: left;
    line-height: 100%;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    /*line-height: 160px;*/
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/ManageHome.vue